import { render } from "./SvgTransition.vue?vue&type=template&id=4870162c&scoped=true"
import script from "./SvgTransition.vue?vue&type=script&lang=js"
export * from "./SvgTransition.vue?vue&type=script&lang=js"

import "./SvgTransition.vue?vue&type=style&index=0&id=4870162c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4870162c"]])

export default __exports__